export default "__VITE_ASSET__BmlCoPk4__"